import { AnimationGroupPlayer } from '@angular/animations/src/players/animation_group_player';
import { formatNumber } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Options } from 'ng5-slider';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from '../api.service';
import { ConfirmacionDatosComponent } from '../blocks/confirmacion-datos/confirmacion-datos.component';
import { ProteccionDatosComponent } from '../blocks/proteccion-datos/proteccion-datos.component';
import { TecnologiaTcComponent } from '../blocks/tecnologia-tc/tecnologia-tc.component';


declare var fbq;
declare var gtag;

@Component({
  selector: 'app-cotizador-tecnologia-opc1',
  templateUrl: './cotizador-tecnologia-opc1.component.html',
  styleUrls: ['./cotizador-tecnologia-opc1.component.css']
}) 
export class CotizadorTecnologiaOpc1Component implements OnInit {
  data: any = {};
  errors: any = []; 
  path: any = "";
  tipoSeguro: any = "Tecnología";
  waTxt: any = ""; 

  isLoading: boolean = false;
  manualSelect: boolean = false;
  manualSelectStep: number = 1;
  cotizador: any = null;
  coberturas: any = null;
  provincias: any = null;
  ocupaciones: any = null;
  nacionalidades: any = null;
  planes: any = null;
  planSeleccionado: any = null;
  ccHorario: any = "";
  isContactSelected: boolean = false;
  
  sa: number = 0;
  saOptions: any = null;
  min_sa: number = 0;
  max_sa: number = 0;

  constructor(
    private api: ApiService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) {

    this.path = this.route.routeConfig.path;

    this.api.getCotizador("TE").subscribe(x => {
      window.scrollTo(0, 0);
      this.cotizador = x.data;
      this.cotizador.codigo = "TE1";
      this.getTopes();
    });

    let tmpCanal = document.location.href.split("?");

    if (tmpCanal[1]) {
      this.data.canal = tmpCanal[1];
    }

    this.api.getHorariosCC().subscribe(x => {
      this.ccHorario = x.data.mensaje;
    });

  }

  captcha(e: any) {
    this.data.captcha = e;
  }

  selectPlan(evt: any) {
    window.scrollTo(0, 0);

    console.log(evt.plan);

    this.planSeleccionado = evt.plan;

    this.data.plan = evt.plan.productoNombre;
    this.data.cuota_mensual = evt.plan.cuota_mensual;

    this.trackEvent("Seleccionar", "Plan Mesuales", evt.plan.displayName);

    this.goToStep(2);

  }

  getTopes() {
    this.api.getCoberturasTopes(this.cotizador.coberturaReferencia).subscribe(x => {

      this.data.sa = 36250;
      this.min_sa = x.data.min;
      this.max_sa = x.data.max;
      this.saOptions = x.data.all;

      if (this.path == 'tecnologia1') {
        this.api.getProductosRecomendadosByCobertura(this.cotizador.coberturaReferencia, this.data.sa).subscribe(x => {
          this.planes = x.data;
          this.data.step = 1;
          this.data.tipo_contacto = "";
        });

      }

      if (this.path == 'tecnologia1-gracias') {

        if (localStorage.getItem("waTxt")) {
          this.waTxt = localStorage.getItem("waTxt");
        }
        
        if (localStorage.getItem("tipoContacto")) {
          this.data.tipo_contacto = localStorage.getItem("tipoContacto");

          switch (this.data.tipo_contacto) {
            case "W":
              this.trackEvent("Seleccionar", "Formulario", "WhatsApp");
              break;
            case "M":
              this.trackEvent("Seleccionar", "Formulario", "Email");
              break;
            case "T":
              this.trackEvent("Seleccionar", "Formulario", "Telefono");
              break;
          }

          this.data.step = 4;
          localStorage.removeItem("tipoContacto");
        } else {
          document.location.href = "tecnologia1";
        }

      }

      if (this.path == 'tecnologia1-nps') {
        this.data.step = 5;
      }

      if (this.path == 'tecnologia1-unsuscribe') {
        this.data.step = 6;
      }

    });
  }

  ngOnInit() {
    // Note: Below 'queryParams' can be replaced with 'params' depending on your requirements
    this.route.queryParams.subscribe(params => {
      console.log(params);
      if (params.canal) {
        switch (params.canal) {
          case "1":
            this.tipoSeguro = {
              titulo: "Celulares",
              singular: "celular",
              css: "ts-celular"
            };
            break;
          case "2":
            this.tipoSeguro = {
              titulo: "Notebooks",
              singular: "notebook",
              css: "ts-notebook"
            };
            break;

          default:
            this.tipoSeguro = {
              titulo: "Tecnología Protegida",
              singular: "equipo",
              css: "ts-generico"
            };

            break;
        }
      } else {
        this.tipoSeguro = {
          titulo: "Tecnología Protegida",
          singular: "equipo",
          css: "ts-generico"
        };
      }
    });
  }

  selectManual() {

    this.trackEvent("Seleccionar", "Plan Personalizado", "Personalizar Plan");

    this.manualSelect = true;
    window.scrollTo(0, 0);
  }

  goToStep(step: number, el: string = "") {
    this.data.step = step;

    if (el == "") {
      window.scrollTo(0, 0);
    } else {
      setTimeout(() => {
        var elmnt = document.getElementById(el);
        elmnt.scrollIntoView();
      }, 500);
    }
  }

  goTo(el: string) {

    if (el == "") {
      window.scrollTo(0, 0);
    } else {

      if(el == 'planes'){
        this.trackEvent("Seleccionar", "Header", "Seleccionar Plan");
      }

      setTimeout(() => {
        var elmnt = document.getElementById(el);
        elmnt.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
    }
  }

  selectPlanPersonalizado() {
    this.trackEvent("Seleccionar", "Plan Personalizado", "Seleccionar");
    this.goToStep(2);
  }

  changePlan() {
    this.trackEvent("Seleccionar", "Formulario", "Modificar");
    this.goToStep(1);
  }

  chooseOtherPlan() {
    this.trackEvent("Seleccionar", "Formulario", "Elegir otro Plan");
    this.goToStep(1);
  }

  cotizar() {

    if (this.manualSelectStep == 1) {
      this.trackEvent("Seleccionar", "Plan Personalizado", "Cotizar");
    }


    this.api.getProductosRecomendadosBySa(this.cotizador.coberturaReferencia, this.data.sa).subscribe(x => {

      this.planSeleccionado = {
        coberturas: x.data.recomendado.coberturas,
        cuota_mensual: x.data.recomendado.cuota_mensual,
        displayName: x.data.recomendado.nombre,
        nombre: x.data.recomendado.nombre,
        productoId: x.data.recomendado.productoId,
        valor: x.data.recomendado.valor
      }

      this.data.plan = this.planSeleccionado.nombre;
      this.data.cuota_mensual = this.planSeleccionado.cuota_mensual;

      this.manualSelectStep = 2;

      this.goTo("planes");
    });
  }

  updateLead(stepTo: number) {
    window.scrollTo(0, 0);

    this.spinner.show();

    this.data.cotizador = this.cotizador.codigo;

    this.api.updateLead(this.data).subscribe(ret => {

      if (ret.status == "ok") {
        if (stepTo == 1) {
          this.errors = [];
          this.data = ret.data;
          this.data.step = stepTo;
          this.spinner.hide();
        }

        if (stepTo == 2) {
          this.errors = [];
          this.data = ret.data;
          this.data.step = stepTo;
          this.spinner.hide();
        }

        if (stepTo == 3) {
          this.errors = [];
          this.data = ret.data;
          this.data.step = stepTo;
          this.trackEvent("Seleccionar", "Formulario", "Guardar");
          this.trackEvent("Seleccionar", "Formulario", "Datos Completos", "Lead");
          this.spinner.hide();
        }

        if (stepTo == 4) {
          this.trackEvent("Seleccionar", "Formulario", "Guardar");
          if (this.data.tipo_contacto == "W") {
            let txt = '¡Hola! Coticé mi seguro de Tecnología Protegida, el precio mensual es $' + formatNumber(this.data.cuota_mensual, 'es-AR', '1.0-0') + ' por una suma asegurada de $' + formatNumber(this.planSeleccionado.valor, 'es-AR', '1.0-0') + '. Mi ID de cotización es ' + this.data.id + '.';
            let num = '+541162217106';
            let url = 'https://wa.me/' + num + '?text=' + txt;  
            let a = document.createElement("a");

            localStorage.setItem("waTxt", txt);

            document.body.appendChild(a);
            a.href = url;
            a.target = "_blank";
            a.click();
            document.body.removeChild(a);

          }

          let params = {
            lead: this.data,
            cotizacion: this.cotizador,
            tipo: this.data.tipo_contacto
          }

          this.api.sendCotizacion(params).subscribe(ret => {
            localStorage.setItem("tipoContacto", this.data.tipo_contacto);
            this.spinner.hide();
            document.location.href = "tecnologia1-gracias";
          });



        }


      }

      if (ret.status == "error") {
        this.errors = ret.errors;
        this.spinner.hide();
      }

    }, err => {
      alert("Se ha producido un error");
    });



  }

  showProteccionDatos() {
    this.modalService.open(ProteccionDatosComponent, { size: <any>'tecno-proteccion-datos' });
  }

  showTC() {
    this.modalService.open(TecnologiaTcComponent, { size: <any>'tecno-proteccion-datos' });
  }

  trackEvent(gAction = null, gCategory = "", gLabel = "", FbEvent = null) {
    if (gAction) {
      gtag('event', gAction, {
        'event_category': gCategory,
        'event_label': gLabel
      });
    }

    if (FbEvent) {
      fbq('track', FbEvent);
    }
  }


}

